export default __webpack_public_path__ + "static/media/Quote.3611933a.svg";